export default {
  SET_NAMESPACES: (state, namespaces) => {
    state.namespaces = namespaces
  },
  SET_NAMESPACE_INDEX: (state, index) => {
    state.namespaceIndex = index
  },
  SET_ENDPOINT_INDEX: (state, index) => {
    state.endpointIndex = index
  },
  SET_BALANCE: (state, balance) => {
    state.balance = balance
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js